import React, { useEffect, useState } from "react";
import { HomeCarousel, HomeMobileCarousel, HomeCategories, CarouselProducts, HalfCarouselProducts, TopPicks } from "../components/homepage";
import { HomeBannerPlaceholder } from "../components/Common/Placeholders";
import { CarouselProducts as CarouselProductsplaceholder, HalfCarouselProducts as HalfCarouselProductsplaceholder } from "../components/placeholders";
import { Container } from "react-bootstrap";
import { MediaQueries } from "../components/utils";
import { useSelector, useDispatch } from "react-redux";
import { ComponentHeader, ProductCard } from "../components/Common";
import { Row, Col } from "react-bootstrap";
import { NavLink, useParams } from 'react-router-dom';
import { getCatScreenList } from '../redux/categoryslice';
import BreadComps from "../components/Common/Breadcomps";
import { Category as CategoryAction } from "../actions";
import InfiniteScroll from "react-infinite-scroll-component";

import { setscrolled_products } from "../redux/categoryslice";
import { pushToDataLayer } from "../components/utils/dataUserpush"
const Category = () => {
    const dispatch = useDispatch();
    const categoryScreen = useSelector(state => state.categoryslice.categoryScreen);
    const loading = useSelector(state => state.categoryslice.loading);
    const categorydata = useSelector((state) => state.globalslice.data);
    const [breadcompdata, setBreadcompdata] = useState([])
    const pathname = window.location.pathname; // "/categories/Laptops-Computers"
    const lastSegment = pathname.split('/').pop(); // "Laptops-Computers"
    const currentcountry = useSelector((state) => state.globalslice.currentcountry);
    useEffect(() => {
        const matchedData = categorydata.find(ele => ele.url === lastSegment);
        setBreadcompdata(matchedData)
    }, []);

    useEffect(() => {
        pushToDataLayer("viewed_category_page", currentcountry.name, {
            category_name: breadcompdata?.category_name,

        }
        );
    }, []);



    const [current_page, setcurrent_page] = useState(1);
    const [has_more, sethas_more] = useState(true);

    const { getAllItems } = CategoryAction()



    const scrolled_products = useSelector(state => state.categoryslice.scrolled_products);
    const deals_offers = useSelector(state => state.homeslice.deals_offers);
    const DealOfTheDay = useSelector(state => state.homeslice.DealOfTheDay);
    const saver_zone = useSelector(state => state.homeslice.saver_zone);
    const TopSelling = useSelector(state => state.homeslice.TopSelling);
    const top_picks = useSelector(state => state.homeslice.top_picks);
    const deals_loading = useSelector(state => state.homeslice.loading1);
    const loading5 = useSelector(state => state.homeslice.loading5);
    const saver_zone_loading = useSelector(state => state.homeslice.loading3);
    const TopSelling_loading = useSelector(state => state.homeslice.loading4);
    const DealOfTheDay_loading = useSelector(state => state.homeslice.loading2);
    const categoryList = useSelector(state => state.globalslice.data);
    const categoryloading = useSelector(state => state.globalslice.loading);

    const { slug } = useParams();

    useEffect(() => {
        setcurrent_page(1)
        sethas_more(true)
        dispatch(setscrolled_products([]))
        dispatch(getCatScreenList(slug))
    }, [slug])


    useEffect(() => {
        getAllItems(slug, current_page, sethas_more)
    }, [current_page])

    const { isMobile } = MediaQueries()


    return (
        <Container fluid className="pt-2 pb-3 homepagecontainer">
            {
                (!isMobile && !categoryloading) &&
                <BreadComps

                    activetitle={breadcompdata?.category_name}

                />
            }

            <div className="mt-3"></div>

            {
                !loading ? (isMobile ?
                    <HomeMobileCarousel carousel_data={categoryScreen.category_image} />
                    :
                    <HomeCarousel carousel_data={categoryScreen.category_image} />
                ) : <HomeBannerPlaceholder height={300} />
            }
            <div className={'mt-4'}></div>
            {
                !categoryloading &&
                <div className="component_1 cat_carousel">
                    <ComponentHeader title={'Shop by Sub-Categories'} view_all={'rgba(82, 50, 194, 1)'} />
                    <HomeCategories category_list={categoryList.filter(({ url }) => url == slug)[0].subcategory} type={2} />
                </div>
            }
            <div className="mt-4"></div>


            <Row className='half_carousel_products'>

                <Col lg={12} className="mb-4">
                    {
                        loading ?
                            <HalfCarouselProductsplaceholder category_list={[1, 2, 3, 4, 5, 6, 7, 8]} type={2} />
                            :
                            <HalfCarouselProducts first_title={'Hot'} second_title={'Deals'} products={categoryScreen.hot_deals} type={1} title={'Hot Deals'} inner_bg={'rgba(255, 250, 229, 1)'} bg_color={'rgba(255, 207, 10, 1)'} first_string_color={'#000'} second_string_color={'rgba(82, 50, 194, 1)'} view_all={'rgba(82, 50, 194, 1)'} />

                    }     </Col>
            </Row>

            <div className="mt-3"></div>

            {
                currentcountry.isTabbyRequired &&
                <div className={`single_banner `}>
                    <img src={'/assets/banners/banner_4.png'} />
                </div>
            }


            {
                !loading &&
                categoryScreen.categories.map((cat => {
                    return (
                        <>
                            <div className={"mt-4"}></div>
                            <div className="component_1">
                                <ComponentHeader title={cat.subcategory_name} url={`/products-category/${cat.url}`} first_title={cat.subcategory_name.split(" ")[0]} second_title={cat.subcategory_name.split(" ")[1]} first_string_color={'#000'} second_string_color={null} view_all={'rgba(82, 50, 194, 1)'} />
                                {
                                    deals_loading ?
                                        <CarouselProductsplaceholder category_list={[1, 2, 3, 4, 5, 6, 7, 8]} />
                                        :
                                        <CarouselProducts products={cat.items} type={1} inner_bg={'rgba(238, 235, 250, 1)'} />
                                }
                            </div>
                        </>

                    )
                }))
            }
            <div className="mt-4"></div>

            <InfiniteScroll

                dataLength={scrolled_products}
                next={() => {
                    setcurrent_page(current_page + 1)
                }}
                hasMore={has_more}
                scrollThreshold={"80%"}
                loader={
                    has_more &&
                    <div style={{ textAlign: "center" }}>
                        <img src='https://www.ourshopee.com/static/media/loader.b7845d8936c686dc2914.gif' />
                    </div>
                }
                // endMessage={<></>}
                // refreshFunction={refresh}
                style={{ overflow: "hidden" }}
            >
                <Row className='mb-4 gx-2 gy-2'>
                    {
                        scrolled_products.map((product) => {
                            return (
                                <Col xxl={2} xl={3} lg={3} md={3} sm={6} xs={6}>
                                    <NavLink to={`/details/${product.url}/${product.sku}`} className={'text-decoration-none'}>
                                        <ProductCard item={product} />
                                    </NavLink>
                                </Col>
                            )
                        })
                    }

                </Row>

            </InfiniteScroll>
        </Container>

    )
}

export default Category;